import { render } from "./Index.vue?vue&type=template&id=6874de5e&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=6874de5e&scoped=true&lang=css"
import "./Index.vue?vue&type=style&index=1&id=6874de5e&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6874de5e"]])

export default __exports__